module.exports = __webpack_public_path__ + "static/media/16UNODC39.cd52fe71.jpg";